import { ANALYTICS_OPT_OUT_COOKIE, ANALYTICS_OPT_OUT_COOKIE_MAX_AGE } from './constants';

export function hasAnalyticsOptOutFromCookieHeader(cookieHeader: string | null | undefined) {
  if (!cookieHeader) {
    return false;
  }

  return cookieHeader.split(';').some((part) => {
    const [name, value] = part.trim().split('=');
    return name === ANALYTICS_OPT_OUT_COOKIE && value === '1';
  });
}

export function hasAnalyticsOptOutFromDocument() {
  if (typeof document === 'undefined') {
    return false;
  }

  return hasAnalyticsOptOutFromCookieHeader(document.cookie);
}

export function hasDoNotTrackEnabled(dntHeader?: string | null) {
  if (dntHeader === '1') {
    return true;
  }

  if (typeof navigator === 'undefined') {
    return false;
  }

  return navigator.doNotTrack === '1' || navigator.doNotTrack === 'yes';
}

export function buildAnalyticsOptOutCookie(value: '1' | '0') {
  const secure =
    typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
  const maxAge = value === '1' ? ANALYTICS_OPT_OUT_COOKIE_MAX_AGE : 0;

  return `${ANALYTICS_OPT_OUT_COOKIE}=${value}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
}

export function setAnalyticsOptOutInDocument(enabled: boolean) {
  if (typeof document === 'undefined') {
    return;
  }

  // biome-ignore lint/suspicious/noDocumentCookie: first-party Article 21 opt-out marker
  document.cookie = buildAnalyticsOptOutCookie(enabled ? '1' : '0');
}
